import { Routes } from "@angular/router";
import { ClientsComponent } from "./clients.component";
import { AddNewClientComponent } from "./components/add-new-client/add-new-client.component";
import { ClientDetailsComponent } from "./components/client-details/client-details.component";
import { VerifyClientComponent } from "./components/verify-client/verify-client.component";
import { QuickVerifyClientComponent } from "./components/quick-verify-client/quick-verify-client.component";
import { ClientsListingInactiveComponent } from "./components/clients-listing-inactive/clients-listing-inactive.component";
import { ClientInvoiceAmountsComponent } from "./components/client-invoice-amounts/client-invoice-amounts.component";

export const clientRoutes: Routes = [
  {
    path: "",
    children: [
      { path: ":id", component: ClientsComponent },
      { path: "expiring-days/:type", component: ClientsComponent },
      { path: ":id/add-new-client", component: AddNewClientComponent },
      { path: "client-details/:id", component: ClientDetailsComponent },
      { path: ":id/verify-client", component: VerifyClientComponent },
      { path: "inactive", component: ClientsListingInactiveComponent },
      { path: ":id/quick-verify", component: QuickVerifyClientComponent },
      {
        path: "open-invoices/:customerAccount/:type",
        component: ClientInvoiceAmountsComponent,
      },
    ],
  },
];
